import React, { useState, useEffect } from "react";
import { Box, Card, Divider, Grid, Tab, Paper, Container } from "@mui/material";
import { Theme } from "@mui/material/styles";
// eslint-disable-next-line no-duplicate-imports
import makeStyles from "@mui/styles/makeStyles";
// eslint-disable-next-line no-duplicate-imports
import createStyles from "@mui/styles/createStyles";
import Typography from "@mui/material/Typography";
import { useMyWinHeightContext } from "src/common/utils/getWindowDimensions";
import CommonTabs from "src/components/CommonTabs/CommonTabs";
import TabHeader from "src/components/TabHeader/TabHeader";
import { Doc } from "./components/Doc/Doc";
import { ProfileInfo } from "./components/Info/ProfileInfo";
import { Notes } from "./components/Notes/Notes";
import { Trades } from "./components/Trades";
import ZipCode from "./components/ZipCode/ZipCode";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      width: "100%",
    },
    pageHeading: {
      fontSize: theme.typography.pxToRem(20),
      color: "#000",
      lineHeight: "28px",
    },
    breadcrumbs: {
      fontSize: theme.typography.pxToRem(12),
    },
    backdrop: {
      zIndex: theme.zIndex.modal + 1,
      color: "#fff",
    },
    ".hidden": {
      overflow: "hidden",
    },
    accordionsSection: {
      overflow: "auto",
      //maxHeight: "calc(100vh - 42vh)",
      //maxHeight: "calc(100vh - 38vh)",
    },
    seeMoreBlock: {
      maxWidth: "150px",
    },
    moreInfoBlock: {
      width: "100%",
      display: "none",
      background: "#f6f6f6",
      position: "absolute",
      top: "40px",
      paddingBottom: "10px",
    },
    ".seeMoreBlock:hover > .moreInfoBlock": {
      background: "red",
    },
    cardMainParent: {
      float: "left",
      width: "100%",
    },
    tabCard: {
      display: "flex",
      flexDirection: "column",
      justifyContent: "space-between",
      boxShadow: "none",
      borderRadius: "0px",
      borderRight: `1px solid ${theme.palette.divider}`,
    },
    tabCardContent: {
      display: "flex",
      flexDirection: "column",
      justifyContent: "space-between",
      boxShadow: "none",
      borderRadius: "0px",
    },
    cardMain: {
      marginBottom: "30px",
      paddingTop: "10px",
      width: "calc(100%)",
    },
  })
);

function a11yProps(index: any) {
  return {
    id: `vertical-tab-${index}`,
    "aria-controls": `vertical-tabpanel-${index}`,
  };
}

type Props = {};

export default function CompanyProfile({}: Props): React.ReactElement {
  const classes = useStyles();
  const { winHeight } = useMyWinHeightContext();
  const [value, setValue] = useState(0);
  useEffect(() => {
    // Cleanup: Remove hidden class on unmount to prevent UI issues
    return () => {
      if (document.body.classList.contains("hidden")) {
        document.body.classList.remove("hidden");
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const [expandedAccordion, setExpandedAccordion] = useState({
    profile: false,
    Trades: false,
    zipCode: false,
    notes: false,
    documents: false,
  });

  const handleChange = (event: React.ChangeEvent<{}>, newValue: number) => {
    setValue(newValue);
    setExpandedAccordion({
      ...expandedAccordion,
      profile: newValue === 0,
      Trades: newValue === 1,
      zipCode: newValue === 2,
      notes: newValue === 3,
      documents: newValue === 4,
    });
  };

  const updateExpandedStatus = (type: number) => {
    setValue(type);
    switch (type) {
      case 0:
        setExpandedAccordion((prev) => {
          return {
            ...prev,
            profile: !prev.profile,
          };
        });
        return;
      case 1:
        setExpandedAccordion((prev) => {
          return {
            ...prev,
            Trades: !prev.Trades,
          };
        });
        return;
      case 2:
        setExpandedAccordion((prev) => {
          return {
            ...prev,
            zipCode: !prev.zipCode,
          };
        });
        return;
      case 3:
        setExpandedAccordion((prev) => {
          return {
            ...prev,
            notes: !prev.notes,
          };
        });
        return;
      case 4:
        setExpandedAccordion((prev) => {
          return {
            ...prev,
            documents: !prev.documents,
          };
        });
        return;
      default:
        return;
    }
  };
  let wHeight = 0;
  const minHeight = 138;
  const minAccHeight = 193;
  const minTabHeight = 255;
  const minAddTabHeight = 60;
  let accordionMaxHeight = 0;
  let tabMinHeight = 0;
  wHeight = winHeight - minHeight;
  accordionMaxHeight = winHeight - minAccHeight;
  tabMinHeight = winHeight - minTabHeight;
  return (
    <>
      <TabHeader
        module={"Company Profile"}
        heading={"Company Profile"}
        linkTo="company-profile"
        pageTitle="TFG | Portal | Company Profile"
      />
      <Box m={2} />

      <Grid container direction="row">
        <Grid item xs={12} md={12} className={classes.cardMainParent} style={{ height: wHeight }}>
          <Paper elevation={3} className={classes.cardMain} style={{ height: wHeight }}>
            <Box pl={2} pr={2}>
              <Grid container direction="row">
                <Grid item xs={12} md={7}>
                  <Typography className={classes.pageHeading}>{"Company Profile"}</Typography>
                </Grid>
              </Grid>
            </Box>
            <Box m={1}>
              <Divider />
            </Box>

            <Grid container>
              <Grid item md={2}>
                <Card className={classes.tabCard}>
                  <CommonTabs
                    value={value}
                    handleChange={handleChange}
                    tabMinHeight={tabMinHeight}
                    minHeight={tabMinHeight + minAddTabHeight}
                  >
                    <Tab label="Profile" {...a11yProps(0)} />
                    <Tab label="Trades" {...a11yProps(1)} />
                    <Tab label="Zip Code" {...a11yProps(2)} />
                    <Tab label="Notes" {...a11yProps(3)} />
                    <Tab label="Documents" {...a11yProps(4)} />
                  </CommonTabs>
                </Card>
              </Grid>
              <Grid item md={10}>
                <Card
                  className={classes.tabCardContent}
                  style={{ height: accordionMaxHeight, overflowY: "auto" }}
                >
                  <Container>
                    <ProfileInfo
                      expand={expandedAccordion.profile}
                      updateExpandStatus={updateExpandedStatus}
                    />
                    <Trades
                      expand={expandedAccordion.Trades}
                      updateExpandStatus={updateExpandedStatus}
                    />
                    <ZipCode
                      expand={expandedAccordion.zipCode}
                      updateExpandStatus={updateExpandedStatus}
                    />
                    <Notes
                      expand={expandedAccordion.notes}
                      updateExpandStatus={updateExpandedStatus}
                    />
                    <Doc
                      expand={expandedAccordion.documents}
                      updateExpandStatus={updateExpandedStatus}
                    />
                  </Container>
                </Card>
              </Grid>
            </Grid>
          </Paper>
        </Grid>
      </Grid>
    </>
  );
}
